var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.breadCrumbData),function(item,index){return _c('router-link',{key:index,staticClass:"active",attrs:{"to":item.breadcrumbLink}},[_vm._v(" "+_vm._s(item.breadcrumbLabel)+" >")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }